// Module
var code = "<div data-bind=\"geWindow: $data, header: 'Order Templates', modalSize: 'lg', align: true\" style=\"background-color:rgba(0,0,0,.5)\"> <div class=\"panel-body\" id=\"divOrderTemplatesPanel\"> <div id=\"orderTemplatesGrid\"></div> </div> </div> ";
// Exports
export default code;